import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { AdminListInterface, RoleListInterface } from '../../../modules/accounts/components/settings/SettingsModel';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { delete_admin, get_all_admins, update_admin } from '../api/adminsApi';
import { toast } from 'react-toastify';
import { KTIcon, KTSVG } from '../../../../_metronic/helpers';
import { Form } from 'react-bootstrap';
import { get_active_roles } from '../../roles/api/rolesApi';
import { permissionCheck } from '../../../helper-functions/PermissionCheck';
import { validateImage } from '../../../helper-functions/ImageValidation';
import { formatDateWithTime } from '../../../helper-functions/DateFunction';

var user_create,user_update,user_delete,user_view, user_activity_log
function AdminsList() {
    const [adminsList, setAdminsList] = useState<AdminListInterface[]>([]);
    const [userPicture, setUserPicture] = useState<File | null>(null);
    const [roleList, setRoleList] = useState<RoleListInterface[]>([]);
    const imageRef = useRef<HTMLInputElement>(null);
    const [selectedAdmin, setSelectedAdmin] = useState<AdminListInterface | null>(null)
    const [searchInput, setSearchInput] = useState('');
    const [selectedItemsPerPage, setSelectedItemsPerPage] = useState(10); // Step 1: State variable for items per page
    const [sortBy, setSortBy] = useState<{ key: string, ascending: boolean } | null>(null); // State variable for sorting
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [firstNameValidationError, setFirstNameValidationError] = useState('');
    const [emailmailValidationError, setEmailValidationError] = useState('');
    const [roleValidationError, setRoleValidationError] = useState('');
    const [visibleData, setVisibleData] = useState<any[]>([]);
    user_create = permissionCheck('user-create');
    user_update = permissionCheck('user-update');
    user_delete = permissionCheck('user-delete');
    user_view = permissionCheck('user-view');
    user_activity_log = permissionCheck('user-activity-log');
    const { data, isLoading, isError,refetch } = useQuery('get_all_admins', get_all_admins, { refetchOnWindowFocus: true });
    const { data:dataRoles } = useQuery('roles', get_active_roles, { refetchOnWindowFocus: false });
           useEffect(() => {
             if (dataRoles) {
               setRoleList(dataRoles.data)
             }
           }, [dataRoles]);
    useEffect(() => {
        if (data) {
            setAdminsList(data.data);
        }
    }, [data]);
    const itemsPerPageOptions = [10, 20, 30, 50, 100]; // Step 2: Options for items per page
    const totalItems = adminsList.length;
    const totalPages = Math.ceil(totalItems / selectedItemsPerPage); // Update total pages based on selected items per page
    useEffect(() => {
        if (adminsList.length > 0) {
          let sortedData = [...adminsList];
          if (sortBy) {
            sortedData.sort((a, b) => {
              const key = sortBy.key;
      
              // Check if the key exists in both objects
              const aValue = a[key] ?? '';
              const bValue = b[key] ?? '';
      
              if (typeof aValue === 'number' && typeof bValue === 'number') {
                // Number sorting
                return sortBy.ascending ? aValue - bValue : bValue - aValue;
              } else if (key.includes('_at') && typeof aValue === 'string' && typeof bValue === 'string') {
                // Date sorting
                return sortBy.ascending
                  ? new Date(aValue).getTime() - new Date(bValue).getTime()
                  : new Date(bValue).getTime() - new Date(aValue).getTime();
              } else {
                // String sorting
                return sortBy.ascending
                  ? aValue.toString().localeCompare(bValue.toString())
                  : bValue.toString().localeCompare(aValue.toString());
              }
            });
          }
      
          // Update visible data with pagination
          setVisibleData(
            sortedData.slice(
              (currentPage - 1) * selectedItemsPerPage,
              currentPage * selectedItemsPerPage
            )
          );
        }
      }, [adminsList, sortBy, currentPage, selectedItemsPerPage,visibleData]);
      
    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        const searchTerm = e.currentTarget.value;
        setSearchInput(searchTerm);
        const filteredItems = data.data.filter((admin) => {
            return admin.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                admin.last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                admin.role?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                admin.email?.toLowerCase().includes(searchTerm.toLowerCase())
        })
         setVisibleData(filteredItems);
        setAdminsList(filteredItems);
    };
    const handleImageChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        logoType: string,
        MAX_FILE_SIZE: number,
        ALLOWED_TYPES: string[],
        MAX_DIMENSIONS: { [key: string]: { width: number; height: number } }
      ) => {
        const newFile = e.target.files?.[0];
        if (newFile) {
          // Call the validation function
          validateImage(
            newFile,
            logoType,
            (validFileUrl) => {
              // If valid, update the state with the image URL
              if (logoType === 'picture') {
                setUserPicture(newFile);
              }
            },
            MAX_FILE_SIZE, // File size limit in MB
            ALLOWED_TYPES, // Allowed file types
            MAX_DIMENSIONS // Maximum dimensions per logo type
          );
        }
      };
    const handleDeleteAdmin = useMutation((id: number) => {
        return delete_admin(id)
            .then((response) => {
                toast.error(response.message, {
                    position: 'top-right',
                    autoClose: 3000,
                })
                get_all_admins()
                    .then((data) => {
                        setAdminsList(data.data)
                        setVisibleData(data.data)
                    })
                    .catch((error: any) => {
                        if (error.response) {
                            const errorMessage = error.response.data.message
                            toast.error(errorMessage, {
                                position: 'top-right',
                                autoClose: 2000,
                            })
                        }
                    })
            })
            .catch((error) => {
                if (error.response) {
                    const errorMessage = error.response.data.message
                    toast.error(errorMessage, {
                        position: 'top-right',
                        autoClose: 2000,
                    })
                }
            })
    });
    // Handle Sort
    const handleSort = (key: string) => {
        setSortBy((prev) =>
          !prev || prev.key !== key
            ? { key, ascending: true } // Sort ascending for a new key
            : { key, ascending: !prev.ascending } // Toggle sorting for the same key
        );
      };
    
    const handleUpdateAdmin = useMutation((updatedAdminData: any) => {
        // Validate required fields
        if (updatedAdminData.first_name.trim() === '') {
            return Promise.reject(new Error('First name is required.'));
        } else if (updatedAdminData.email.trim() === '') {
            return Promise.reject(new Error('Email is required.'));
        } else if (updatedAdminData.role.trim() === '') {
            return Promise.reject(new Error('Role is required.'));
        }
    
        // Create FormData to send the image and other data
        const formData:any= new FormData();
        formData.append('first_name', updatedAdminData.first_name);
        formData.append('last_name', updatedAdminData.last_name || ''); // Ensure last name is empty if not provided
        formData.append('email', updatedAdminData.email);
        formData.append('role', updatedAdminData.role);
    
        // Only append the image if it exists
        if (userPicture) {
            formData.append('profile_picture', userPicture);
        }
    
        // Log FormData to verify content
        for (let pair of formData.entries()) {
            console.log(pair[0] + ": " + pair[1]); 
        }
    
        // Assuming `update_admin` accepts FormData
        return update_admin(updatedAdminData.id, formData)
            .then((data) => {
                toast.success(data.message, {
                    position: 'top-right',
                    autoClose: 3000,
                });
                refetch();
                // Refresh the admin list after updating
                get_all_admins()
                    .then((data) => {
                        setAdminsList(data.data);
                        setVisibleData(data.data)
                    })
                    .catch((error) => {
                        toast.error('List Not Updated!', {
                            position: 'top-right',
                            autoClose: 3000,
                        });
                    });
            })
            .catch((error) => {
                // Handle API error
                toast.error(error.response?.data?.message || 'Error occurred.', {
                    position: 'top-right',
                    autoClose: 3000,
                });
            });
    });
    
    
    
    
    const handleUserRoleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        if (selectedAdmin) {
          const newRoleName = e.target.value;
          if (!newRoleName) {
            setRoleValidationError('Role is required.');
          } else {
            setRoleValidationError('');
          };
          setSelectedAdmin({
            ...selectedAdmin,
            role: newRoleName,
          });
        };
      };
    const resetValidationErrors = () => {
        setFirstNameValidationError('');
        setEmailValidationError('');
        setRoleValidationError("");
    // Clear the image by resetting its src
   imageRef.current && (imageRef.current.value = '');
    }
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const handleAdminLogs = (admin: any) => {
        navigate("/admins/log", { state: { id: admin.id } });
      };
    return (
        <div className='card card-xxl-stretch mx-4 mb-5 mb-xl-10'>
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>List of Admins</span>
                </h3>
                 {
                    user_create && (
                        <div
                        className='card-toolbar'
                    >
                        <button
                            data-toggle="tooltip" data-placement="bottom" title="Navigate to Add Admin"
                            className='btn btn-sm btn-light-dark'
                            onClick={() => navigate('/admins/add-admin')}
                        >
                            <KTIcon iconName='plus' className='fs-3' />
                            Add Admin
                        </button>
                    </div>
                    )
                 }
            </div>
            <div className='card-header border-0 pt-5'>
                {/* begin::Search */}
                <h3 className='card-title align-items-start flex-column'>
                    <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                    <input
                        data-toggle="tooltip" data-placement="bottom" title="Search an Admin"
                        type='text'
                        data-kt-user-table-filter='search'
                        className='form-control form-control-solid w-250px ps-14'
                        placeholder='Search Admin'
                        value={searchInput}
                        onChange={handleInputChange}
                    />
                </h3>
                {/* end::Search */}
                {/* <div
            className='card-toolbar'
          >
            <h5 className='p-3'>Filter by:</h5>
            <div>
              <select
                className='form-select form-select-solid form-select-lg fw-bold'
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value=''>Filter by Status...</option>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>
          </div> */}
            </div>
            <div className='card-body py-3'>
                <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead>
                            <tr className='fw-bold text-muted'>
                                <th className='min-w-50px'>Picture<span onClick={() => handleSort('profile_picture')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-120px'>Name<span onClick={() => handleSort('full_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                {/* <th className='min-w-150px'>Last Name<span onClick={() => handleSort('last_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th> */}
                                <th className='min-w-120px'>Role<span onClick={() => handleSort('role')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-150px'>Email<span onClick={() => handleSort('email')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-90px'>Created At<span onClick={() => handleSort('created_at')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-140px'>Updated By<span onClick={() => handleSort('updated_by_name')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                <th className='min-w-90px'>Updated At<span onClick={() => handleSort('updated_at')}> <KTIcon iconName='up-down' className='fs-4 cursor-pointer' /></span></th>
                                {
                                    user_delete || user_update || user_view ?(
                                        <th className='min-w-100px text-center'>Actions</th>
                                    ):null
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {isError ? (
                                <tr>
                                    <td>Error loading data. Please try again later.</td>
                                </tr>
                            ) : isLoading ? (
                                <tr>
                                    <td colSpan={6}>
                                        <div className='text-center'>
                                            <div className='spinner-border' role='status'>
                                                <span className='visually-hidden'>Loading...</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ) : visibleData.length > 0 ? (
                                visibleData.map((admin) => (
                                    <tr key={admin.id}>
                                        <td>
                                            <div className='symbol'>
                                                {admin.profile_picture === null ? (
                                                    <div className="symbol symbol-circle symbol-50px">
                                                        <div className="symbol-label  fs-1 fw-bold text-inverse-dark bg-dark">{admin.first_name ? admin.first_name[0].toUpperCase() : ''}</div>
                                                    </div>
                                                ) : (
                                                    <img alt='User Picture' src={admin?.profile_picture} />
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start flex-column'>
                                                    <h3 className='text-dark fw-bold fs-6'>
                                                        {admin.full_name}
                                                    </h3>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start flex-column'>
                                                    <h3 className='text-dark fw-bold fs-6'>
                                                        {admin.role}
                                                    </h3>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex justify-content-start flex-column'>
                                                    <h3 className='text-dark fw-bold fs-6'>
                                                        {admin.email}
                                                    </h3>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex flex-column w-80 me-2'>
                                                <div className='d-flex flex-stack mb-2'>
                                                    {formatDateWithTime(admin.created_at)}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex flex-column w-100 me-2'>
                                                <div className='d-flex flex-stack mb-2'>
                                                    {admin.updated_by_name}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex flex-column w-80 me-2'>
                                                <div className='d-flex flex-stack mb-2'>
                                                    {formatDateWithTime(admin.updated_at)}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex justify-content-center flex-shrink-0'>
                                          {
                                            user_view && (
                                                <button
                                            data-toggle="tooltip" data-placement="bottom" title="View Admin"
                                            className='btn btn-icon btn-light-dark btn-active-color-success btn-sm me-2'
                                            data-bs-toggle='modal'
                                            data-bs-target='#kt_modal_5'
                                            onClick={() => setSelectedAdmin({...admin})}
                                        >
                                            <KTIcon iconName='eye' className='fs-3' />
                                            </button>
                                            )
                                          }
                                                {user_activity_log && (
                                                    <button
                                                        onClick={() => {
                                                            handleAdminLogs(admin)
                                                        }}
                                                        className='btn btn-icon btn-light-dark btn-active-color-warning btn-sm me-1'
                                                        data-bs-toggle='tooltip'
                                                        data-bs-placement='top'
                                                        data-bs-custom-class='tooltip-dark'
                                                        title='Admin Logs'
                                                    >
                                                        <i className='bi bi-journal-text'></i>
                                                    </button>
                                                )}
                                                {
                                                    user_update && (
                                                        <button
                                                            data-toggle="tooltip" data-placement="bottom" title="Edit Admin"
                                                            onClick={() => {
                                                                setSelectedAdmin({ ...admin });
                                                                resetValidationErrors();
                                                    }}
                                                    data-bs-toggle='modal'
                                                    data-bs-target='#kt_modal_2'
                                                    className='btn btn-icon btn-light-dark btn-active-color-warning btn-sm me-1'
                                                >
                                                    <KTIcon iconName='pencil' className='fs-3' />
                                                </button>
                                                )
                                            }
                                            {
                                                user_delete && (
                                                <button
                                                    data-toggle="tooltip" data-placement="bottom" title="Delete Admin"
                                                    onClick={() => setSelectedAdmin({ ...admin })}
                                                    className='btn btn-icon btn-light-dark btn-active-color-danger btn-sm'
                                                    data-bs-toggle='modal'
                                                    data-bs-target='#kt_modal_1'
                                                >
                                                    <KTIcon iconName='trash' className='fs-3' />
                                                </button>
                                                )
                                            }
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td>No Admins Available.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="modal fade" tabIndex={-1} id="kt_modal_5">
    <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title fs-3">View Admin</h5>
                <button
                    type="button"
                    className="btn btn-icon btn-lg btn-active-light-primary"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr061.svg"
                        className="svg-icon svg-icon-3x"
                    />
                </button>
            </div>
            <div className="modal-body px-4">
                {selectedAdmin ? (
                    <div className="row">
                        {/* Profile Picture */}
                        <div className="col-md-4 d-flex align-items-center justify-content-center mb-4 mb-md-0">
                            {selectedAdmin.profile_picture === null ? (
                                <div className="symbol symbol-circle symbol-150px">
                                    <div className="symbol-label fs-1 fw-bold text-inverse-dark bg-dark">
                                        {selectedAdmin.first_name ? selectedAdmin.first_name[0].toUpperCase() : ''}
                                    </div>
                                </div>
                            ) : (
                                <img
                                    src={selectedAdmin.profile_picture}
                                    className="img-fluid edit-organisation-img rounded"
                                    alt="User Picture"
                                />
                            )}
                        </div>
                        {/*Admin Details */}
                        <div className="col-md-8">
                        <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Role:</label>
                                <div className="col-7 fs-3">{selectedAdmin.role}</div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Email:</label>
                                <div className="col-7 fs-3">{selectedAdmin.email}</div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">First Name:</label>
                                <div className="col-7 fs-3">{selectedAdmin.first_name || 'N/A'}</div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Last Name:</label>
                                <div className="col-7 fs-3">{selectedAdmin.last_name || 'N/A'}</div>
                            </div>
                            <div className="row mb-3">
                                      <label className="col-5 fw-bold fs-3">Permissions:</label>
                                      <div className="col-7 fs-3">
                                          <div>
                                         All
                                          </div>
                                      </div>
                                  </div>
                        </div>
                    </div>
                ) : (
                    <div className="fs-3 text-center">No User Data Available</div>
                )}
            </div>
        </div>
    </div>
</div>
            <div className='card-footer d-flex justify-content-between py-4'>
                <div className='align-items-center row'>
                    <div className='d-flex'>
                        <div className='col-md-9 mt-5'><strong>Results Per Page:</strong></div>
                        <select
                            style={{ width: '60px' }}
                            className='form-select form-select-md px-2 col-md-1'
                            value={selectedItemsPerPage}
                            onChange={(e) => setSelectedItemsPerPage(Number(e.target.value))}
                        >
                            {itemsPerPageOptions.map(option => (
                                <option key={option} value={option} className='p-3 '>{option}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className='d-flex justify-content-end'>
                    {currentPage === 1 ? (
                        <button
                            className='btn btn-light'
                            onClick={handlePreviousPage}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary'
                            onClick={handlePreviousPage}
                            disabled={currentPage === 1}
                        >
                            Previous
                        </button>
                    )}
                    <button
                        className='btn btn-primary ms-2'
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
            <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
                <div className='modal-dialog'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Delete Admin Confirmation</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            {selectedAdmin ? (
                                <>
                                    <p className='mb-2'>
                                        <span className='fw-bold fs-5'>First Name:</span> {selectedAdmin.first_name}
                                    </p>
                                    <p className='mb-2'>
                                        <span className='fw-bold fs-5'>Email:</span> {selectedAdmin.email}
                                    </p>
                                </>
                            ) : null}
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                                Close
                            </button>
                            <button
                                type='button'
                                className='btn btn-danger'
                                onClick={() => {
                                    if (selectedAdmin) {
                                        handleDeleteAdmin.mutate(selectedAdmin.id)
                                    }
                                }}
                                data-bs-dismiss='modal'
                            >
                                Delete Admin
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
                <div className='modal-dialog modal-dialog-centered modal-lg'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Edit Admin</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            {selectedAdmin ? (
                                <>
                                <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>Role</span>
                </label>
                <div className='col-lg-8 fv-row'>
                  <select
                    className='form-select form-select-solid form-select-lg fw-bold'
                    value={selectedAdmin.role || ""}
                    onChange={(e) => {
                      handleUserRoleChange(e)
                    }}
                  >
                    <option value=''>Select a Role...</option>
                    {Array.isArray(roleList) && roleList.map((rolType) => (
                                        <option key={rolType.id} value={rolType.name}>
                                            {rolType.name}
                                        </option>
                                    ))}
                  </select>
                  {roleValidationError && (
                    <div className='text-danger'>{roleValidationError}</div>
                  )}
                </div>
              </div>
                                    <div className='mb-2 row mb-6'>
                                        <label className='col-lg-4 ml-4 col-form-label required fw-bold fs-6'>
                                            First Name
                                        </label>
                                        <div className='col-lg-8 fv-row'>
                                            <input
                                                value={selectedAdmin.first_name || ""}
                                                placeholder='First Name'
                                                className='form-control form-control-lg form-control-solid'
                                                onChange={(e) => {
                                                    if (!e.target.value) {
                                                        setFirstNameValidationError('First name is required.')
                                                    } else {
                                                        setFirstNameValidationError('')
                                                    }
                                                    setSelectedAdmin({
                                                        ...selectedAdmin,
                                                        first_name: e.target.value,
                                                    })
                                                }}
                                                type='text'
                                            />
                                            {firstNameValidationError && (
                                                <div className='text-danger'>{firstNameValidationError}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='mb-2 row mb-6'>
                                        <label className='col-lg-4 ml-4 col-form-label fw-bold fs-6'>
                                            Last Name
                                        </label>
                                        <div className='col-lg-8 fv-row'>
                                            <input
                                                value={selectedAdmin.last_name || ""}
                                                placeholder='Last Name'
                                                className='form-control form-control-lg form-control-solid'
                                                onChange={(e) => {
                                                    setSelectedAdmin({
                                                        ...selectedAdmin,
                                                        last_name: e.target.value,
                                                    })
                                                }}
                                                type='text'
                                            />
                                        </div>
                                    </div>
                                    <div className='mb-2 row mb-6'>
                                        <label className='col-lg-4 ml-4 col-form-label required fw-bold fs-6'>
                                            Email
                                        </label>
                                        <div className='col-lg-8 fv-row'>
                                            <label className='form-control form-control-lg form-control-solid user-input'>
                                                {selectedAdmin.email || ""}
                                            </label>
                                        </div>
                                    </div>
                                    <div className='row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>Picture</label>
                                        <div className='col-lg-8 fv-row'>
                                            <input
                                                type='file'
                                                ref={imageRef}
                                                className='form-control form-control-lg form-control-solid'
                                                onChange={(e) => handleImageChange(
                                                    e,
                                                    'picture',
                                                    2, // Max file size (2MB)
                                                    ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                                                    {
                                                      picture: { width: 200, height: 200 }
                                                    } // Max dimensions
                                                  )}
                                                accept="image/jpeg, image/jpg, image/png"
                                                name='picture'
                                            />
                                            <div className='text-danger mt-2'>
                                                Recommended size: 200 x 200 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
                                            </div>
                                            {selectedAdmin?.profile_picture ? (
                                                <div className='mt-2'>
                                                    <img
                                                        src={selectedAdmin?.profile_picture}
                                                        alt='User Picture'
                                                        className='symbol'
                                                        width={200}
                                                        height={200}
                                                    />
                                                </div>
                                            ) : (
                                                <div className='mt-2 text-muted'>No existing image</div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                                Close
                            </button>
                            {selectedAdmin?.first_name === '' || selectedAdmin?.email === '' || selectedAdmin?.role===''  ? (
                                <>
                                    <button type='button' className='btn btn-light-dark' disabled={true}>
                                        Update Admin
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        type='button'
                                        className='btn btn-primary'
                                        onClick={() => {
                                            if (selectedAdmin && selectedAdmin.first_name && selectedAdmin.email) {
                                                handleUpdateAdmin.mutateAsync({
                                                    id: selectedAdmin.id,
                                                    first_name: selectedAdmin.first_name,
                                                    last_name: selectedAdmin.last_name,
                                                    email: selectedAdmin.email,
                                                    role:selectedAdmin.role,
                                                    userPicture:userPicture
                                                })
                                            }
                                        }}
                                        data-bs-dismiss='modal'
                                    >
                                        Update Admin
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};
export default AdminsList